import React from "react";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import { TooltipButton } from "components/common/TooltipButton";

import { TableWithModel } from "./useDeleteAccount";

interface CriticalTableRowProps {
  table: TableWithModel;
  onMove: () => void;
}

export const CriticalTableRow: React.FC<CriticalTableRowProps> = ({
  table,
  onMove,
}) => (
  <div className="min-h-(--item-height) flex items-center gap-2 pr-2 group rounded-app transition-colors hover:bg-list-hover">
    <TableChartOutlinedIcon className="icon-sm text-fg-regular shrink-0 ml-3" />
    <span className="text-fg-regular truncate">{table.table_name}</span>
    <span className="text-fg-muted-regular truncate text-xs">
      {table.model_name}
    </span>

    <div className="flex-1" />
    <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity">
      <TooltipButton
        title="Move to another model"
        aria-label={`Move ${table.table_name} to another model`}
        variant="contextual"
        size="xs"
        onClick={onMove}
      >
        <DriveFileMoveOutlinedIcon />
      </TooltipButton>
    </div>
  </div>
);
